import { useCallback, useRef, useState } from "react";

export function usePageLoader() {
  const [isLoading, setIsLoading] = useState(false);
  const loadingCounterRef = useRef(0);

  const start = useCallback(() => {
    loadingCounterRef.current += 1;
    setIsLoading(true);
  }, []);

  const stop = useCallback(() => {
    loadingCounterRef.current = Math.max(0, loadingCounterRef.current - 1);
    if (loadingCounterRef.current === 0) setIsLoading(false);
  }, []);

  const runWithLoading = useCallback(
    async <T,>(fn: () => Promise<T>): Promise<T> => {
      start();
      try {
        return await fn();
      } finally {
        stop();
      }
    },
    [start, stop],
  );

  return { isLoading, start, stop, runWithLoading };
}

